export default "__VITE_ASSET__D$x8qZkE__"